class JLFSearch {
	constructor() {
		this.buildSearchInput();
		this.buildResultPage();
	}

	buildSearchInput() {
		this.searchContainer = document.querySelector(".search-container");
		this.searchForm = this.searchContainer.querySelector("form");
		this.toggleSearch = this.searchContainer.querySelector(".toggle-search");
		this.searchInput = this.searchContainer.querySelector("#jlfSearch");
		this.closeSearch = this.searchContainer.querySelector(".close-search");
		this.isOpen = false;
		this.toggleSearch.addEventListener("click", () => {
			if (this.isOpen) {
				if (this.searchInput.value.length > 2) {
					this.searchForm.submit();
				}
			} else {
				this.searchContainer.classList.add("open");
				this.searchInput.focus();
				this.isOpen = true;
			}
		});

		this.closeSearch.addEventListener("click", () => {
			this.searchContainer.classList.remove("open");
			this.isOpen = false;
		});
	}

	buildResultPage() {
		if (document.body.classList.contains("search-results")) {
			let words = document.querySelector("[data-search-value]").dataset.searchValue;
			if (!words) {
				return;
			}
			words = words.split(" ");
			if (words.length) {
				words.forEach(word => {
					document.querySelectorAll(".search-result .meta, .search-result h2 a").forEach(elem => {
						elem.innerHTML = elem.innerHTML.replace(new RegExp('(' + word + ')', 'ig'), '<span class="searched-word">$1</span>');
					});
				});
			}
		}
	}
}
